import PopularProductsTable from './PopularProductsTable'

export default PopularProductsTable
